function removeSpaces(str) {
    return str
        .toLowerCase()             // Convert to lowercase
        .replace(/[^a-z0-9]+/g, '_');  // Replace spaces and special characters with underscores
}
export default removeSpaces